import React from 'react';
import stackedDesktop from '../assets/stacked1-desktop.png';
import stackedMobile from '../assets/stacked1.png';

export default function FeatureSection() {
  return (
    <section className="feature-section">
      <div className="section-container reverse">
        <div className="section-image-wrapper">
          <img 
            src={stackedDesktop}
            srcSet={`${stackedMobile} 768w, ${stackedDesktop} 1920w`}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt="Organized photos" 
            className="section-image"
          />
        </div>
        <div className="section-content">
          <h2 className="section-title">Your photos organized and instantly searchable.</h2>
          <p className="section-text">
            MyPictor makes it easy to organize your entire photo collection. With AI-powered search, 
            you can find any photo in seconds—by people, location, events, or even what's in the picture.
          </p>
        </div>
      </div>
    </section>
  );
}
